import styled from 'styled-components';
import { Grid, TextField, Box, FormControlLabel, RadioGroup, IconButton, Typography, FormControl, Button } from '@mui/material';
import { CustomButton } from 'components/ButtonCustom/style';
import Card from "@mui/material/Card";

export const FormGrid = styled(Grid)`
  font-size: 16px;
  font-weight: 400;
  margin-top: 10px;
  margin-bottom: 30px;
  
  .MuiFormControlLabel-root {
    margin-left: 0;
    margin-right: 0;
  }
  
  .MuiCheckbox-root, .MuiRadio-root {
    padding: 4px;
  }
`

export const FormTitleGrid = styled(Grid)`
  font-size: 18px;
  font-weight: 400;

  .subTitle {
    font-size: 16px;
    opacity: 0.75;
  }
`

export const BadgeGrid = styled(Grid)`
  font-size: 15px;
  padding: 7px 20px;
  border-radius: 5px;
  background: linear-gradient(180deg, #9e5302 0%, #8e110c 155.15%),#FB7E04;
  text-align: center;
  min-width: 100px;
  min-height: 41px;
`

export const InputContainer = styled(Grid)`
  .readOnly {
      .MuiOutlinedInput-notchedOutline {
      height: 45px;
      border-radius: 10px;
      border: 0.4px solid;
      border-color: transparent !important;
    }
  }
`

export const InputGrid = styled(Grid)`
  gap: 20px;
  .MuiOutlinedInput-input {
    color: #FFFFFF;
  }
  .MuiOutlinedInput-notchedOutline {
    border-color: rgba(255, 255, 255, 0.2) !important;
    border-width: 1px;
  }
  .MuiInputBase-root.Mui-focused {
    box-shadow: 0px 0px 10px #FC6508;
    svg {
      color: #E22B00;
    }
    .MuiOutlinedInput-input {
      color: #E22B00;
    }
  }
  .MuiFormHelperText-root{
    margin-top: 5px;
  }
  & .MuiOutlinedInput-root.Mui-focused{
    & > fieldset {
      border-color: transparent;
    }
  }
`

export const PlatformContainer = styled(Grid)(({ theme }) => ({
  marginBottom: '20px',
  display: 'flex',
  flexWrap: 'wrap',
  gap: '10px'
}));

export const PlatformButton = styled('div')(({ theme }) => ({
  width: '60px',
  height: '60px',
  borderRadius: '5px',
  backgroundColor: '#1E1B1A',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  cursor: 'pointer',
  transition: 'all 0.3s ease',
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
  },
  '&.selected': {
    backgroundColor: 'rgba(250, 125, 77, 0.5)',
    border: '2px solid #FA7D4D',
  }
}));

export const PlatformLabel = styled('div')(({ theme }) => ({
  textAlign: 'center',
  fontSize: '12px',
  marginTop: '5px',
  color: '#ffffff'
}));

export const Input = styled(TextField)`
  background-color: transparent;
  border-radius: 10px;
  width: 100%;
  min-height: 40px;
`

export const ProjectCard = styled(Card)`
  background: linear-gradient(127.09deg, rgba(0, 0, 0, 0.6) 19.41%, rgba(0, 0, 0, 0.6) 76.65%) !important;
  && {
    overflow: auto;
    max-height: 80vh;
  }
`

export const SectionTitle = styled('h3')(({ theme }) => ({
  color: '#ffffff',
  fontSize: '16px',
  marginBottom: '10px',
  fontWeight: 500
}));

export const ZeCommunityImage = styled(Card)`
  height: 100%;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.5) !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: 'center';
`;

export const FormTitleText = styled('p')`
  font-size: 32px;
`;

export const FormSubTitle = styled('p')`
  font-size: 16px;
  opacity: 0.75;
`;

export const FormHeaderContainer = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 16px;
`;

export const FormHeaderBadgeContainer = styled(Grid)`
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  gap: 10px;
`;

export const FormSectionTitle = styled(SectionTitle)`
  color: #8F8F8F;
`;

export const FormErrorText = styled('div')`
  color: #f44336;
  margin-top: 8px;
  font-size: 12px;
`;

export const FormRadioGroup = styled(RadioGroup)`
  gap: 50px;
`;

export const FormCheckboxLabel = styled(FormControlLabel)`
  color: white;
`;

export const FormButtonContainer = styled(Grid)`
  justify-content: flex-end;
  margin-top: 16px;
`;

export const FormCancelButton = styled(CustomButton)`
  padding: 14px 32px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 8px;
  min-width: 200px;
  text-transform: none;
  background: transparent;
  border: 2px solid #FC6508;
  color: #FC6508;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

export const FormSubmitButton = styled(CustomButton)`
  cursor: ${props => props.isSubmitting ? 'not-allowed' : 'pointer'};
`;

export const CalendarTitleGrid = styled(Grid)`
  font-size: 18px;
  font-weight: 400;
  border-radius: 8px;
  position: relative;
  overflow: hidden;
  width: 100%;
  text-align: center;
  
  p {
    margin: 0;
    color: #FC6508;
    font-size: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .subTitle {
    font-size: 16px;
    color: #fff;
    opacity: 0.8;
    margin: 10px auto 0;
    line-height: 1.5;
    max-width: none;
  }
`

export const ModalContainer = styled(Box)`
  background-color: #101010;
  border-radius: 25px;
  padding: 0;
  width: 90%;
  max-width: 650px;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
  border: 1px solid rgba(255, 255, 255, 0.45);
  color: #fff;
`;

export const CloseButton = styled(IconButton)`
  position: absolute !important;
  right: 8px !important;
  top: 8px !important;
  color: #F2F2F2 !important;
`;

export const ModalTitle = styled(Box)`
  display: flex;
  padding: 16px;
  padding-left: 24px;
`;

export const ModalTitleText = styled(Typography)`
  color: #fff !important;
  font-weight: bold;
  text-align: center;
`;

export const ModalContent = styled(Box)`
  padding: 24px;
  padding-left: 30px;
`;

export const FormSection = styled(Box)`
  margin-bottom: 32px;
`;

export const RadioGroupContainer = styled(FormControl)`
  margin-bottom: 32px;
`;

export const ButtonContainer = styled(Box)`
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
  margin-right: 24px;
  margin-bottom: 24px;
`;

export const SubmitButton = styled(CustomButton)`
  background-color: ${props => props.disabled ? '#666 !important' : '#FC6508 !important'};
  color: #fff;
  padding: 12px 24px;
  border-radius: 8px;
  width: 200px;
  
  &:hover {
    background-color: ${props => props.disabled ? '#666 !important' : '#e45400 !important'};
  }
  
  &:disabled {
    background-color: #666 !important;
    color: #999 !important;
  }
`;

export const InputGridBuildScript = styled(Grid)`
  .MuiOutlinedInput-input {
    color: #FFFFFF;
  }
  .MuiInputBase-root.Mui-focused {
    box-shadow: 0px 0px 10px #FC6508;
    svg {
      color: #E22B00;
    }
    .MuiOutlinedInput-input {
      color: #E22B00;
    }
  }
  .MuiAutocomplete-endAdornment {
    top: 5px !important;
    transform: none !important;
  }
  .MuiAutocomplete-root .MuiAutocomplete-input {
    padding-top: 0 !important;
  }
  .MuiAutocomplete-root .MuiOutlinedInput-root {
    padding-top: 5px !important;
  }
  .MuiAutocomplete-popper {
    background-color: #0E0E0E;
    border: 1px solid;
  }
  .MuiFormHelperText-root{
    margin-top: 5px;
  }
  & .MuiOutlinedInput-root.Mui-focused{
    & > fieldset {
      border-color: transparent;
    }
  }
  .MuiPaper-root-MuiAutocomplete-paper {
    border-radius: 5px !important;
  }
  .MuiPaper-root{
    border-radius: 5px !important;
  }
  svg {
    color: white;
  }
`

export const InputBuildScript = styled(TextField)`
  background-color: transparent;
  /* border: 0.4px solid rgba(255, 255, 255, 0.50) !important; */
  border-radius: 10px;
  width: 100%;
  min-height: 40px;
`

export const EditButton = styled(Button)`
  && {
    gap: 10px;
    width: 180px;
    height: 40px;
    border-radius: 5px;
    color: #fff;
    font-size: 14px;
    font-weight: 500;
    background: linear-gradient(180deg, #FB8404 0%, #FE1E14 100%);
    padding: 6px 6px;

    &:hover{
      transform: scale(1.1);
      color: #fff;
    }
  }
`